import React from 'react';
import { Typography } from '@material-ui/core';

export const CopyRights = () => (
 <Typography variant='caption' display='block' color="textSecondary" gutterBottom>
  Copyright © OrangeTreeApps, LLC. All rights reserved.
 </Typography>
);
